/**
 * Laenge der Scroll-Pille links im Reader (Benedikt 29.09.2026): wie eine
 * Browser-Scrollleiste — die Pille ist so lang wie der sichtbare Anteil an der
 * ganzen Story. Kurze Story = lange Pille, lange Story = kurze Pille; man sieht
 * am Balken, wie lang die Story ist.
 *
 * Grenzen: unter 16 px wird sie zum Punkt und schwer zu greifen (sie ist
 * anfassbar), ueber 120 px ist sie kein leiser Hinweis mehr.
 */
export const PILLE_MIN = 16;
export const PILLE_MAX = 120;

/**
 * @param spur        verfuegbare Hoehe fuer Pille + Weg (Viewport minus Raender)
 * @param sichtbar    sichtbare Hoehe (Viewport bzw. Scroll-Container)
 * @param gesamt      ganze Scroll-Hoehe der Story
 */
export function pillenLaenge(spur: number, sichtbar: number, gesamt: number): number {
  if (spur <= 0) return 0;
  const obergrenze = Math.min(PILLE_MAX, spur);
  if (gesamt <= 0 || sichtbar <= 0 || gesamt <= sichtbar) return obergrenze;
  const roh = (spur * sichtbar) / gesamt;
  return Math.round(Math.min(obergrenze, Math.max(PILLE_MIN, roh)));
}
